import { FormEvent, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';

import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';
import { database } from '../services/firebase';

import illustrationImg from '../assets/images/illustration.svg';
import logoImg from '../assets/images/logo.svg';
import logoDarkImg from '../assets/images/logo-dark.svg';
import googleIconImg from '../assets/images/google-icon.svg';

import { PageAuth } from '../styles/auth';

import { DefaultButton } from '../components/Button';

export function Home() {
  const { theme } = useTheme();
  const history = useHistory();
  const { user, signInWithGoogle } = useAuth();
  const [roomCode, setRoomCode] = useState('');

  async function handleCreateRoom() {
    if (!user) {
      await signInWithGoogle();
    }

    history.push('/rooms/new');
  }

  async function handleJoinRoom(event: FormEvent) {
    event.preventDefault();

    if (roomCode.trim() === '') {
      toast('Digite o código da sala', { icon: '⚠️'});
      return;
    }

    const roomRef = await database.ref(`rooms/${roomCode}`).get();

    if (!roomRef.exists()) {
      toast.error('Ops! Esta sala não existe.');
      return;
    }

    if (roomRef.val().endedAt) {
      toast.error('Esta sala está fechada.');
      return;
    }

    history.push(`/rooms/${roomCode}`);
  }

  return (
    <PageAuth>
      <Toaster />

      <aside>
        <img src={illustrationImg} alt="Ilustração simbolizando perguntas e respostas" />
        <strong>Crie salas de Q&amp;A ao-vivo</strong>
        <p>Tire as dúvidas da sua audiência em tempo-real</p>
      </aside>

      <main>
        <div className="main-content">
          <img src={theme.title === 'dark' ? logoDarkImg : logoImg} alt="Letmeask" />

          <button className="create-room" onClick={handleCreateRoom}>
            <img src={googleIconImg} alt="Logo do google" />
            Cria sua sala com o Google
          </button>

          <div className="separator">
            ou entre em uma sala
          </div>

          <form onSubmit={handleJoinRoom}>
            <input
              type="text"
              placeholder="Digite o código da sala"
              onChange={event => setRoomCode(event.target.value)}
              value={roomCode}
            />

            <DefaultButton type="submit">
              Entrar na sala
            </DefaultButton>
          </form>
        </div>
      </main>
    </PageAuth>
  );
}